import styled from 'styled-components';

export const VideoWrapper = styled.video`
  width: 100%;
`;
